import { EnhancedCouponData } from "./coupon-wall";

export enum QuickSelectionType {
  Common = 1,
  Coupon = 2,
}

export interface QuickSelection {
  id: number | string;
  name: string;
  value: number | string;
  iconUrl: string | null;
}

export interface CouponSelection extends QuickSelection {
  coupon: EnhancedCouponData | null;
  value: number;
}

export interface Tab {
  id: number | null;
  type: number | null; // tabType
  name: string;
  imgUrl: string | null;
  quickSelection: Array<QuickSelection> | null;
  listScene: number;
  segmentIdList: number[]; // Tab 对应的数据片列表
}

export interface TabbarLxConfig {
  TABBAR_BID_MV: {
    TAB: string;
    QUICK_SELECTION: string;
  },
  TABBAR_BID_MC: {
    TAB: string; // 标签栏Tab
    QUICK_SELECTION: string; // 快筛
  }
}